import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import setAdminAuthorizationToken from "../../services/axios-util/set-admin-authorization-token";

/** A higher-order component with conditional routing logic */
export function withCondition(
  Component: FunctionComponent,
  redirectTo: string
) {
  return function InnerComponent(props: any) {
    const { admin } = useSelector((state: any) => state.adminAuth);
    if (admin.authorization) setAdminAuthorizationToken(admin.authorization);
    return admin.authorization ? (
      <Component {...props} />
    ) : (
      <Navigate to={redirectTo} replace />
    );
  };
}

export const checkLoggedInAdmin = (Component: React.FunctionComponent) =>
  withCondition(Component, "/login");
